import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-quickview',
  templateUrl: 'quickview.html',
})
export class QuickviewPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
outColorIn: string;
outColorOut: string;
selectedGriffe: string;
selectedOrnament: any; 
selectedVerglasung: any; 
selectedKante: string;
selectedSprossentyp: any;
selectedSprossenmuster: any;
selectedSprossenfarbe: any;
selectedRahmenLinks: any;
selectedRahmenRechts: any;
selectedRahmenOben: any;
selectedRahmenUnten: any;
noInfo: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
  
     this.noInfo = "Keine Angaben";

    this.selectedRahmenLinks = this.navParams.get('selectedRahmenLinks');
    this.selectedRahmenRechts = this.navParams.get('selectedRahmenRechts');
    this.selectedRahmenOben = this.navParams.get('selectedRahmenOben'); 
    this.selectedRahmenUnten = this.navParams.get('selectedRahmenUnten');
    this.selectedSprossentyp = this.navParams.get('selectedSprossentyp');
    this.selectedSprossenmuster = this.navParams.get('selectedSprossenmuster');
    this.selectedSprossenfarbe = this.navParams.get('selectedSprossenfarbe');
    this.selectedOrnament = this.navParams.get('selectedOrnament');
    this.selectedVerglasung = this.navParams.get('selectedVerglasung');
    this.selectedKante = this.navParams.get('selectedKante');
    this.selectedGriffe = this.navParams.get('selectedGriffe');
    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
     
  if (this.productname == null || this.productname == "undefined"){
  this.productname = this.noInfo;
  }
  if (this.producttype == null || this.producttype == "undefined"){
  this.producttype = this.noInfo;
  }
  if (this.windowtype == null || this.windowtype == "undefined"){
  this.windowtype = this.noInfo;
  }
  if (this.typeopen == null || this.typeopen == "undefined"){
  this.typeopen = this.noInfo;
  }
  if (this.windowlong == null || this.windowlong == "undefined"){
  this.windowlong = this.noInfo;
  }
  if (this.windowwide == null || this.windowwide == "undefined"){
  this.windowwide = this.noInfo;
  }
  if (this.outColorOut == null || this.outColorOut == "undefined"){
  this.outColorOut = this.noInfo;
  }
  if (this.outColorIn == null || this.outColorIn == "undefined"){
  this.outColorIn = this.noInfo;
  }
  if (this.dichtungen == null || this.dichtungen == "undefined"){
  this.dichtungen = this.noInfo;
  }
  if (this.selectedGriffe == null || this.selectedGriffe == "undefined"){
  this.selectedGriffe = this.noInfo;
  }
  if (this.selectedKante == null || this.selectedKante == "undefined"){
  this.selectedKante = this.noInfo;
  }
  if (this.selectedVerglasung == null || this.selectedVerglasung == "undefined"){
  this.selectedVerglasung = this.noInfo;
  }
  if (this.selectedOrnament == null || this.selectedOrnament == "undefined"){
  this.selectedOrnament = this.noInfo;
  }
  if (this.selectedSprossenfarbe == null || this.selectedSprossenfarbe == "undefined"){
  this.selectedSprossenfarbe = this.noInfo;
  }
  if (this.selectedSprossenmuster == null || this.selectedSprossenmuster == "undefined"){
  this.selectedSprossenmuster = this.noInfo;
  }
  if (this.selectedSprossentyp == null || this.selectedSprossentyp == "undefined"){
  this.selectedSprossentyp = this.noInfo;
  }
  if (this.selectedRahmenUnten == null || this.selectedRahmenUnten == "undefined"){
  this.selectedRahmenUnten = this.noInfo;
  }
  if (this.selectedRahmenOben == null || this.selectedRahmenOben == "undefined"){
  this.selectedRahmenOben = this.noInfo;
  }
  if (this.selectedRahmenRechts == null || this.selectedRahmenRechts == "undefined"){
  this.selectedRahmenRechts = this.noInfo;
  }
  if (this.selectedRahmenLinks == null || this.selectedRahmenLinks == "undefined"){
  this.selectedRahmenLinks = this.noInfo;
  }
  
     
     
     
         console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.dichtungen, this.outColorIn, this.outColorOut, this.selectedGriffe, this.selectedKante, this.selectedVerglasung, this.selectedOrnament, this.selectedSprossentyp, this.selectedSprossenfarbe, this.selectedSprossenmuster, this.selectedRahmenLinks, this.selectedRahmenRechts, this.selectedRahmenOben, this.selectedRahmenUnten); 
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuickviewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/quickview/quickview.ts